/**
 * @type {string}
 * @memberof ProviderType
 */
export const Log4js = 'LOG4JS'
/**
 * @type {string}
 * @memberof ProviderType
 */
export const Console = 'CONSOLE'

/**
 * @namespace ProviderType
 * @description Define the static types
 */
export default {
  Log4js,
  Console
}
